<script setup lang="ts">
import { ref } from 'vue'
import { VIcons } from '@/shared/ui'

withDefaults(
  defineProps<{
    label: string
    rules?: Array<(value: unknown) => boolean | string>
    multiple?: boolean
    loading?: boolean
    disabled?: boolean
  }>(),
  {
    rules: () => [],
    multiple: false,
    loading: false,
    disabled: false,
  },
)

const model = defineModel<File[] | File | null>()

const fileInputRef = ref<{ $el: HTMLElement } | null>(null)

/**
 * Открывает системный диалог выбора файла по клику на иконку.
 */
const openFilePicker = () => {
  fileInputRef.value?.$el?.querySelector<HTMLInputElement>('input[type="file"]')?.click()
}
</script>

<template>
  <VFileInput
    ref="fileInputRef"
    v-model="model"
    prepend-icon=""
    :label="label"
    :rules="rules"
    :multiple="multiple"
    :loading="loading"
    :disabled="disabled"
  >
    <template #prepend>
      <VTooltip location="top" :text="$t('itf.attach_files_from_computer')">
        <template #activator="{ props: tipProps }">
          <VBtn
            icon
            variant="text"
            density="compact"
            v-bind="tipProps"
            :aria-label="$t('itf.attach_files_from_computer')"
            :disabled="disabled"
            @click="openFilePicker"
          >
            <VIcons type="attach_file_add" />
          </VBtn>
        </template>
      </VTooltip>
    </template>

    <template v-if="$slots.selection" #selection>
      <slot name="selection" />
    </template>
  </VFileInput>
</template>
